import {BOTTOM_NAV_AUTO_HIDE} from "../constants/bottom_nav_auto_hide";

interface IParams {
    accumulatedDelta: number;
    canScroll: boolean;
    distanceFromBottom: number;
    hideLockPx: number;
    isHidden: boolean;
    previousScrollY: number;
    scrollY: number;
}

interface IResult {
    accumulatedDelta: number;
    isHidden: boolean;
}

export const resolveMobileBottomNavHidden = (params: IParams): IResult => {
    const {accumulatedDelta, canScroll, distanceFromBottom, hideLockPx, isHidden, previousScrollY, scrollY} = params;

    if (!canScroll) return {accumulatedDelta: 0, isHidden: false};
    if (scrollY <= BOTTOM_NAV_AUTO_HIDE.TOP_PX) return {accumulatedDelta: 0, isHidden: false};
    // Overscroll and padding clamp look like an upward scroll; hold state until the user leaves the edge.
    if (distanceFromBottom <= hideLockPx) return {accumulatedDelta: 0, isHidden};

    const delta = scrollY - previousScrollY;

    if (delta === 0) return {accumulatedDelta, isHidden};

    const isSameDirection = accumulatedDelta === 0 || Math.sign(accumulatedDelta) === Math.sign(delta);
    const nextAccumulatedDelta = isSameDirection ? accumulatedDelta + delta : delta;

    if (nextAccumulatedDelta >= BOTTOM_NAV_AUTO_HIDE.SCROLL_DELTA_PX) return {accumulatedDelta: 0, isHidden: true};
    if (nextAccumulatedDelta <= -BOTTOM_NAV_AUTO_HIDE.SCROLL_DELTA_PX) return {accumulatedDelta: 0, isHidden: false};

    return {accumulatedDelta: nextAccumulatedDelta, isHidden};
};
import {BOTTOM_NAV_AUTO_HIDE} from "../constants/bottom_nav_auto_hide";

interface IParams {
    accumulatedDelta: number;
    canScroll: boolean;
    distanceFromBottom: number;
    hideLockPx: number;
    isHidden: boolean;
    previousScrollY: number;
    scrollY: number;
}

interface IResult {
    accumulatedDelta: number;
    isHidden: boolean;
}

export const resolveMobileBottomNavHidden = (params: IParams): IResult => {
    const {accumulatedDelta, canScroll, distanceFromBottom, hideLockPx, isHidden, previousScrollY, scrollY} = params;

    if (!canScroll) return {accumulatedDelta: 0, isHidden: false};
    if (scrollY <= BOTTOM_NAV_AUTO_HIDE.TOP_PX) return {accumulatedDelta: 0, isHidden: false};
    // Overscroll and padding clamp look like an upward scroll; hold state until the user leaves the edge.
    if (distanceFromBottom <= hideLockPx) return {accumulatedDelta: 0, isHidden};

    const delta = scrollY - previousScrollY;

    if (delta === 0) return {accumulatedDelta, isHidden};

    const isSameDirection = accumulatedDelta === 0 || Math.sign(accumulatedDelta) === Math.sign(delta);
    const nextAccumulatedDelta = isSameDirection ? accumulatedDelta + delta : delta;

    if (nextAccumulatedDelta >= BOTTOM_NAV_AUTO_HIDE.SCROLL_DELTA_PX) return {accumulatedDelta: 0, isHidden: true};
    if (nextAccumulatedDelta <= -BOTTOM_NAV_AUTO_HIDE.SCROLL_DELTA_PX) return {accumulatedDelta: 0, isHidden: false};

    return {accumulatedDelta: nextAccumulatedDelta, isHidden};
};
